// extracted by mini-css-extract-plugin
export default {"marginTop":"A_IjqZqdORutu0uslqle","defaultClass":"I_IRJ93vNpZvCRl9ywVA"};